import packageJson from '@/../package.json';
import { getLangByCountry } from '@/config/application/langConfig';
import { getGTMByCountry } from '@/config/application/gtmConfig';
import { getConfigSurveyByCountry } from '@/config/application/surveyMonkeyConfig';

import {
  getClientIdByCountry,
  IFRAME_PROD,
  IFRAME_SANDBOX,
  IFRAME_PAGENAME,
} from '@/config/application/paas';
import {
  BRASPAG_ORG_ID,
  BRASPAG_PROVIDER_MERCHANT_ID,
  IFRAME_URL_FINGERPRINT,
} from '@/config/application/braspag';


const jsonConfig = {
  COUNTRY: process.env.REACT_APP_COUNTRY,
  USE_GENERATED_ENV: process.env.REACT_APP_USE_GENERATED_ENV,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  API_URL: process.env.REACT_APP_API_URL,
  WHMCS_URL: process.env.REACT_APP_WHMCS_URL,
  SITE_HG: process.env.REACT_APP_SITE_HG,
  TICKETS_API_URL: process.env.REACT_APP_TICKETS_API_URL,
  TICKETS_API_URL_V2: process.env.REACT_APP_TICKETS_API_URL_V2,
  RECAPTCHA_PAAS: process.env.REACT_APP_RECAPTCHA_PAAS,
  NEW_RECAPTCHA_PAAS: process.env.REACT_APP_NEW_RECAPTCHA_PAAS,
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  AWS_PRODUCT_LIFECYCLE_URL: process.env.REACT_APP_AWS_PRODUCT_LIFECYCLE_URL,
  AWS_SITEBUILDER_URL: process.env.REACT_APP_AWS_SITEBUILDER_URL,
  AWS_DNS_SERVICE_URL: process.env.REACT_APP_AWS_DNS_SERVICE_URL,
  AWS_AHC_URL: process.env.REACT_APP_AWS_AHC_URL,
  SURVEY_API: process.env.REACT_APP_SURVEY_API,
  AWS_PRO_EMAIL_URL: process.env.REACT_APP_AWS_PRO_EMAIL_URL,
  CHECKOUT_URL: process.env.REACT_APP_CHECKOUT_URL,
  PASS_BASE_URL: process.env.REACT_APP_PASS_BASE_URL,
  CART_URL: process.env.REACT_APP_CART_URL,
  AMPLITUDE_KEY: process.env.REACT_APP_AMPLITUDE_KEY,
  AWS_GATOR_SOLUTIONS_URL: process.env.REACT_APP_AWS_GATOR_SOLUTIONS_URL,
  CACHED_AWS_GATOR_SOLUTIONS_URL: process.env.REACT_APP_CACHED_AWS_GATOR_SOLUTIONS_URL,
  GROWTHBOOK_CLIENT_KEY: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  LINK_NA_BIO_URL: process.env.REACT_APP_LINK_NA_BIO_URL,
  ECOMMERCE_RD_TOKEN: process.env.REACT_APP_ECOMMERCE_RD_TOKEN,
  CHAT_TOKEN: process.env.REACT_APP_CHAT_TOKEN,
  ZENDESK_AUTH_TOKEN: process.env.REACT_APP_ZENDESK_AUTH_TOKEN,
  ZENDESK_AUTH_KEY: process.env.REACT_APP_ZENDESK_AUTH_KEY,
  STUDIO_DOMAIN: process.env.REACT_APP_STUDIO_DOMAIN,
  CLIENTAREA_URL: process.env.REACT_APP_CLIENTAREA_URL,
  DATADOG_PUBLIC_CLIENT_KEY: process.env.REACT_APP_DATADOG_PUBLIC_CLIENT_KEY,
};

export const {
  COUNTRY,
  REACT_APP_USE_GENERATED_ENV,
  ENVIRONMENT,
  SITE_HG,
  WHMCS_URL,
  AWS_DNS_SERVICE_URL,
  AWS_AHC_URL,
  DATADOG_PUBLIC_CLIENT_KEY,
  CART_URL,
  AMPLITUDE_KEY,
  AWS_GATOR_SOLUTIONS_URL,
  CACHED_AWS_GATOR_SOLUTIONS_URL,
  GROWTHBOOK_CLIENT_KEY,
  ECOMMERCE_RD_TOKEN,
  LINK_NA_BIO_URL,
  CHAT_TOKEN,
  ZENDESK_AUTH_TOKEN,
  ZENDESK_AUTH_KEY,
  STUDIO_DOMAIN,
  CLIENTAREA_URL,
} = jsonConfig;

export const IS_PROD = ENVIRONMENT === 'production';

const VIMEO_TOKEN = IS_PROD ? 'e16beae5a3dbd4e7175704daa30be829' : 'b49be9c65d5d18c845bbe4201ede99c7';
const PAYPAL_ENVIRONMENT = IS_PROD ? 'production' : 'sandbox';

const CLIENT_ID_PAAS = getClientIdByCountry(COUNTRY);

const PAAS_CONFIG = IS_PROD ? {
  IFRAME_URL: IFRAME_PROD,
  CLIENT_ID: CLIENT_ID_PAAS,
  IFRAME_PAGENAME,
} : {
  IFRAME_URL: IFRAME_SANDBOX,
  CLIENT_ID: CLIENT_ID_PAAS,
  IFRAME_PAGENAME,
};

const BRASPAG_CONFIG = {
  IFRAME_URL_FINGERPRINT,
  MERCHANT_ID: BRASPAG_PROVIDER_MERCHANT_ID,
  ORG_ID: BRASPAG_ORG_ID,
};

export const countrySurvey = {
  br: 1,
  mx: 2,
  cl: 3,
  co: 4,
  ar: 13,
  pe: 14,
  ec: 15,
  do: 16,
  uy: 17,
  cr: 18,
  bo: 19,
  py: 20,
  sv: 21,
  pa: 22,
};

export const wizardCountrySurvey = {
  br: 5,
  mx: 6,
  cl: 7,
  co: 8,
  ar: 23,
  pe: 24,
  ec: 25,
  do: 26,
  uy: 27,
  cr: 28,
  bo: 29,
  py: 30,
  sv: 31,
  pa: 32,
};

export const costumerPortalSurvey = {
  br: 9,
  mx: 10,
  cl: 11,
  co: 12,
  ar: 33,
  pe: 34,
  ec: 35,
  do: 36,
  uy: 37,
  cr: 38,
  bo: 39,
  py: 40,
  sv: 41,
  pa: 42,
};

export const config = {
  LANG: getLangByCountry(COUNTRY),
  CACHE_TIME: 60000,
  GTM: getGTMByCountry(COUNTRY),
  VIMEO_TOKEN,
  AWS_AHC_URL,
  PAYPAL_ENVIRONMENT,
  AWS_DNS_SERVICE_URL,
  PAAS_CONFIG,
  BRASPAG_CONFIG,
  AWS_GATOR_SOLUTIONS_URL,
  CACHED_AWS_GATOR_SOLUTIONS_URL,
  ECOMMERCE_RD_TOKEN,
  SURVEY_CONFIG: getConfigSurveyByCountry(COUNTRY),
  CHAT_TOKEN,
  ZENDESK_AUTH_TOKEN,
  ZENDESK_AUTH_KEY,
  STUDIO_DOMAIN,
  CLIENTAREA_URL,
  ...jsonConfig,
};

export const APP_VERSION = `Versão ${packageJson.version}`;
